import { Group, Switch, Text, useComputedColorScheme, useMantineColorScheme } from "@mantine/core";
import { IconMoon, IconSun } from "@tabler/icons-react";

/**
 * Light/dark Switch for the profile dropdown. Renders as a plain padded row
 * (NOT a Menu.Item) so clicking the Switch doesn't close the surrounding Menu.
 * The choice persists via the MantineProvider's localStorage scheme manager.
 */
export function ThemeToggle() {
  const { setColorScheme } = useMantineColorScheme();
  // The actually-rendered scheme (resolves "auto" and the persisted value).
  const isDark = useComputedColorScheme("light", { getInitialValueInEffect: true }) === "dark";

  return (
    <Group justify="space-between" px="sm" py="xs" wrap="nowrap">
      <Text size="sm">Dark mode</Text>
      <Switch
        size="sm"
        checked={isDark}
        onChange={(event) => setColorScheme(event.currentTarget.checked ? "dark" : "light")}
        onLabel={<IconMoon size={12} stroke={2.5} />}
        offLabel={<IconSun size={12} stroke={2.5} />}
        aria-label="Toggle dark mode"
      />
    </Group>
  );
}
